var config = require('../config.js')
module.exports = {
  getTheaterInfo: config.host + '/tktbc/api/v1/showindex/get/c',  // 获取场馆信息
  getTheaterInfoCom: config.host + '/tktbc/api/v1/showindex/getTheaterBaseInfo/c',  // 获取场馆信息合并接口
  getTheaterShowList: config.host + '/tktbc/api/v1/showindex/list/c',  // 获取场馆演出列表
  getTheaterShowListNew: config.host + '/tktbc/api/v1/showindex/list/v2/c',  // 获取场馆演出列表
  // getTheaterShowListNew: config.host + '/tktbc/api/v1/showindex/list/v4/c',  // 获取场馆演出列表
  // getShowDetail: config.host + '/tktbc/api/v1/cshow/detail/c',  // 获取演出票务详情
  getShowDetail: config.host + '/tktbc/api/v1/cshow/detail/v2/c',  // 获取演出票务详情
  // getShowDetail: config.host + '/tktbc/api/v1/cshow/detail/v4/c',  // 获取演出票务详情
  getShowSchedule: config.host + '/tktbc/api/v1/cshow/schedule/c',  // 获取演出票档
  // getShowScheduleNew: config.host + '/tktbc/api/v1/cshow/scheduleV2/c',  // 获取演出票档
  getShowScheduleNew: config.host + '/tktbc/api/v1/cshow/scheduleV2/v2/c',  // 获取演出票档
  getShowSeatTicket: config.host + '/tktbc/api/v1/cshow/getShowSeatTicket/c',  // 座位选择页面获取演出票档
  // getShowSeatTicket: '/localtktbc/api/v1/cshow/getShowSeatTicket/c',  // 座位选择页面获取演出票档
  // getShowSeatTicket: config.host + '/tktbc/api/v1/cshow/getShowSeatTicket/v4/c',  // 座位选择页面获取演出票档
  getMemberCanEarlyBuy: config.host + '/tktbc/api/v1/showindex/getMemberCanEarlyBuy/c',  // 座位选择页面获取演出票档前查询是否有提前购
  getShowTimeAndTicketApi: config.host + '/tktbc/api/v1/cshow/getShowTimeAndTicket/c',  // 获取新的演出票档
  // getShowTimeAndTicketApi: config.host + '/tktbc/api/v1/cshow/getShowTimeAndTicketV4/c',  // 获取新的演出票档
  getMemberEarlyBuyList: config.host + '/tktbc/api/v1/showindex/getMemberEarlyBuyList/c',  // 会员提前购场次列表
  getShowDetailRetail: config.host + '/tktbc/api/v1/cshow/retail/detail/c',  // 获取演出票务详情
  getShowScheduleRetail: config.host + '/tktbc/api/v1/cshow/retail/schedule/c',  // 获取演出票档
  sendViewNum: config.host + '/tktbc/api/v1/cshow/view/c',  // 提交一次浏览数
  hasTickets: config.host + '/tktbc/api/v1/cshow/hasTickets/c',  // 校验票数
  // recommendShows: config.host + '/tktbc/api/v1/cshow/recommend/c',  // 推荐演出
  recommendShows: config.host + '/tktbc/api/v1/cshow/recommend/v2/c',  // 推荐演出
  retailManageQueryShow: config.host + '/retail/api/v1/retailManage/queryShow/c',  // 查询渠道商演出
}